<script setup>
import {ref} from 'vue';
import {useLocalisedDates} from "~/composables/useLocalisedDates";
const {shortDate} = useLocalisedDates();

const props = defineProps({
  bouncedEmailReason: {
    type: String,
    required: true
  },
  bouncedEmailCreatedAt: {
    type: String,
    default: null
  }
});

const dialog = ref(false);
const getBounceMessage = () => {
  if (props.bouncedEmailReason === 'BOUNCE') {
    return 'This email bounced, no further emails will be sent to this address';
  } else if (props.bouncedEmailReason === 'COMPLAINT') {
    return 'We received a complaint about sending to this email, please contact the user to check';
  }
  return `Email issue: ${props.bouncedEmailReason}`;
};
</script>

<template>
  <div class="d-inline-block">
    <v-btn color="error" size="x-small" icon @click.stop="dialog = true">
    <v-icon
        icon="mdi-email-remove-outline"
        class="cursor-pointer"
    />
    </v-btn>

    <v-dialog v-model="dialog" max-width="500">
      <div class="tl-card pa-4">
        <div class="d-flex align-center mb-3">
          <v-icon icon="mdi-email-remove-outline" color="error" size="large" class="mr-3" />
          <h3 class="text-h6">Email Delivery Issue</h3>
        </div>

        <div
            class="pa-3 mb-3 d-flex align-center"
            style="background: rgb(var(--v-theme-light)); border:1px solid rgb(var(--v-theme-borderLight)); border-radius:10px; font-size:12.5px;"
        >
          <v-icon icon="mdi-alert-circle-outline" :style="{ color: 'rgb(var(--v-theme-error))' }" class="mr-2" />
          {{ getBounceMessage() }}
        </div>

        <div v-if="bouncedEmailCreatedAt" class="text-caption text-medium-emphasis mb-3">
          Issue occurred: {{ shortDate(bouncedEmailCreatedAt) }}
        </div>

        <div class="d-flex justify-end">
          <v-btn
              color="primary"
              variant="text"
              @click="dialog = false"
          >
            Close
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
